import { Analytics } from "./analytics";

export function analyticsCollectorCasinoTopBanner() {
    const $items = $(".casino-banner");
    if (!$items.length) {
        return;
    }

    $items.each((_, element) => {
        Analytics.addPromoHeroCard(
            element,
            "VerticalList",
            `vertical.list.${Analytics.vertical}.top`,
            ".casino-banner__img"
        );
    });
}
